import { GratitudesApi } from 'api';
import {  Api } from 'api/cabmun-content-public';
import useUserData from 'hooks/useUserData';
import { useReducer, useState, useMemo, useEffect } from 'react';
import { Section } from '@gr-monorepo/common/models/gratitude';
export let monthes: { month: string; monthIndex: number }[] =
  'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'
    .split('_')
    .map((el, i) => ({ month: el, monthIndex: i + 1 }));
monthes = [...monthes.slice(8), ...monthes.slice(0, 8)].reverse();
export type Gratitude = Api.Gratitude & { year: string; month: number; isNew: boolean };
export const sectionKeys = [Section.school, Section.municipality];

export const useGratitudes = (lastVisited: number) => {
  const [currentYear, setCurrentYear] = useState<{ id: string; label: string } | null>(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [store, setStore] = useState<Gratitude[]>([]);
  const byYear = useMemo(() => store.filter((el) => el.year === currentYear?.id), [store, currentYear]);

  const bySectionAndMonth = useMemo(() => {
    return byYear.reduce((acc, el) => {
      const section = el.section || -1;
      return { ...acc, [section]: { ...(acc[section] || {}), [el.month]: [...(acc[section]?.[el.month] || []), el] } };
    }, {} as Record<number, Record<number, Gratitude[]>>);
  }, [byYear]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await GratitudesApi.getGratitudes();
        setStore(
          result.map((el) => {
            const [year, month] = el.created_at.slice(0, 7).split('-');
            return {
              ...el,
              year: +month < 9 ? `${+year - 1}/${year}` : `${year}/${+year + 1}`,
              month: +month,
              isNew: lastVisited < new Date(el.created_at).getTime(),
            };
          }),
        );
      } catch (e) {
        setError(true);
      }

      setLoaded(true);
    };
    fetchData();
  }, [currentYear]);

  return {
    currentYear,
    setCurrentYear,
    loaded,
    error,
    bySectionAndMonth,
    store,
  };
};

export type Gratitudes = ReturnType<typeof useGratitudes>;
